import { Component, Input, OnInit } from '@angular/core';
import { SparePart } from 'src/app/api/spareParts/sparePart';
import { SparePartsPackage } from 'src/app/api/spareParts/sparePartsPackage';
import { SparePartViewModel } from './sparePartViewModel';

@Component({
    selector: 'spare-parts-list',
    templateUrl: './spare-parts-list.component.html',
    styleUrls: ['./spare-parts-list.component.css'],
    standalone: false
})
export class SparePartsListComponent implements OnInit {
  @Input() spareParts: SparePart[] | undefined = undefined;
  @Input() sparePartsPackage: SparePartsPackage | undefined = undefined;
  dataSource: SparePartViewModel[] = [];
  displayedColumns: string[] = ['PartNumber', 'Description', 'TechData', 'EstimatedPmHours'];

  ngOnInit(): void {
    if (this.spareParts) {
      this.dataSource = this.spareParts
        .map(x => SparePartViewModel.CreateForSinglePart(x));
      this.displayedColumns.push('details');
    }

    if (this.sparePartsPackage) {
      this.dataSource = this.sparePartsPackage
        .SparePartsInPackages
        .map(x => SparePartViewModel.CreateForPackage(x));
      this.displayedColumns.push('Quantity', 'details');
    }
  }
}
